import { AuthLayout, LoginForm } from '../components/features/auth';
import { MountainBackground } from '../components/layout';

export function LoginPage() {
  return (
    <MountainBackground variant="prominent">
      <AuthLayout
        title="Welcome back"
        subtitle="Sign in to continue your recovery journey"
      >
        <LoginForm />
      </AuthLayout>
    </MountainBackground>
  );
}
